// src/assets/images/index.js
export { default as garage } from './background_garage.jpg';
export { default as garderner } from './background_gardener.jpg';
export { default as plumber } from './background_plumber.jpg';
export { default as physiotherapist } from './background_physiotherapist.jpg';
export { default as defaultImage } from './about.jpg';